// On browser load (everytihing has downloaded and is ready have loaded)
window.onload = function() {
  'use strict';

  // Find all maps and initialize
  var maps = document.getElementsByClassName('acf-map'); 

  if (maps) {

    for (var i=0; i < maps.length; i++) {

      var zoom_level = parseInt(maps[i].dataset.zoom);
      var map_view = maps[i].dataset.mapType;

      var zoom_type = (maps[i].classList.contains('fit-to-boundries') ? "fit-to-boundries" : 'zoom-main-marker');

      var settings = {
        zoom:         zoom_level,
        zoom_type:    zoom_type, 
        map_type_id:  map_view
      }
      var google_map = new _90d_acf_google_map(settings);
      google_map.init();

      // Get all classes on map item and initialize additional features
      var maps_classes = maps[i].classList;

      mapFeaturesLoader(maps_classes, google_map);
    }  
  } 
};

function mapFeaturesLoader(maps_classes, google_map) {
  if(typeof google === 'undefined') {
    setTimeout(function() {
      mapFeaturesLoader(maps_classes, google_map);
    },1000);
  } else {
    for (var t=0; t < maps_classes.length; t++) {
      switch(maps_classes[t]) {
        case 'directions':
          google_map.directions_init();
          break;
      }          
    }
  }
}



